export class BillingInfoEntry {
  constructor(data, companyId) {
    this.date = data?.date ?? "";
    this.dispatcherId = data?.dispatcherId ?? null;
    this.numberOfOrders = data?.numberOfOrders ?? 0;
    this.numberOfPaidOrders = data?.numberOfPaidOrders ?? 0;
    this.billableAmount = data?.billableAmount ?? 0;
    this.discountAmount = data?.discountAmount ?? 0;
    this.companyId = companyId;
  }
}

export class MonthlyBilling {
  constructor(data = {}) {
    this.id = data?.id ?? null;
    this.administratorId = data?.administratorId ?? null;
    this.paymentSource = data?.paymentSource ?? "";
    this.keyType = data?.keyType ?? null;
    this.key = data?.key ?? null;
    this.companies = Array.isArray(data?.companies) ? data.companies : [];
    this.startDate = data?.startDate ?? "";
    this.usageAmount = Number(data?.usageAmount ?? 0);
    this.chargedAt = data?.chargedAt ?? null;
    this.isPaid = data?.isPaid ?? false;
    this.chargingStatus = data?.chargingStatus ?? "";
  }

  getId() {
    return this.id;
  }

  getPaymentSource() {
    return this.paymentSource;
  }

  getAdministratorId() {
    return this.administratorId;
  }

  getKeyType() {
    return this.keyType;
  }

  getKey() {
    return this.key;
  }

  getCompanies() {
    return this.companies;
  }

  getStartDate() {
    return this.startDate;
  }

  getUsageAmount() {
    return this.usageAmount;
  }

  getChargedAt() {
    return this.chargedAt;
  }

  getIsPaid() {
    return this.isPaid;
  }

  getChargingStatus() {
    return this.chargingStatus;
  }
}

export class LastMonthBilling {
  constructor(data = {}) {
    this.isPaid = data?.isPaid ?? true;
    this.pendingAmount = Number(data?.pendingAmount ?? 0);
    this.failedBills = Array.isArray(data?.failedBills)
      ? data.failedBills.map((billing) => new MonthlyBilling(billing))
      : [];
  }

  getIsPaid() {
    return this.isPaid;
  }

  getPendingAmount() {
    return this.pendingAmount;
  }

  getFailedBills() {
    return this.failedBills;
  }
}

export class BillingDetailsMap {
  constructor(companiesBilling = []) {
    this.billingFormattedObj = this.buildFormattedObj(companiesBilling);
    this.calculateTotals();
  }

  buildFormattedObj(flatList) {
    const dateTracker = {};

    if (!Array.isArray(flatList)) {
      return dateTracker;
    }

    flatList.forEach((companyBilling) => {
      const companyId = companyBilling?.companyId;
      const billingInfos = companyBilling?.billingInfos ?? [];

      billingInfos.forEach((bill) => {
        if (dateTracker[bill.date] === undefined) {
          dateTracker[bill.date] = { date: bill.date, billingInfos: [] };
        }

        dateTracker[bill.date].billingInfos.push(new BillingInfoEntry(bill, companyId));
      });
    });

    return dateTracker;
  }

  calculateTotals() {
    Object.keys(this.billingFormattedObj).forEach((date) => {
      let totalOrders = 0;
      let totalPaidOrders = 0;
      let totalBillingAmount = 0;
      let totalDiscountAmount = 0;

      this.billingFormattedObj[date].billingInfos.forEach((billingData) => {
        totalOrders += billingData.numberOfOrders;
        totalPaidOrders += billingData.numberOfPaidOrders;
        totalBillingAmount += billingData.billableAmount;
        totalDiscountAmount += billingData.discountAmount;
      });

      this.billingFormattedObj[date].totalOrders = totalOrders;
      this.billingFormattedObj[date].totalPaidOrders = totalPaidOrders;
      this.billingFormattedObj[date].totalBillingAmount = totalBillingAmount;
      this.billingFormattedObj[date].totalDiscountAmount = totalDiscountAmount;
      this.billingFormattedObj[date].billedAccountsCount =
        this.billingFormattedObj[date].billingInfos.length;
    });
  }

  getBillingInfoByDate(date) {
    return this.billingFormattedObj[date];
  }
}
